module.exports = __webpack_public_path__ + "img/schgz-black-text.53c30f88.png";